export const getValuesRecharge = (operatorKey, areaCode) => {
  return {
    type: 'FETCH_CREDITVALUE',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/mobileRecharges/mobileoperator/${operatorKey}/areacode/${areaCode}/rechargeValue`
      }
    }
  }
}
export const clearAreaCodes = () => {
  return {
    type: 'CLEAR_CREDITVALUE'
  }
}
export default {
  getValuesRecharge,
  clearAreaCodes
}



// WEBPACK FOOTER //
// ./src/features/CellphoneRecharge/ValuesRecharge/actions.js